import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthDialogService {
  // Dialog state subjects
  private loginDialogSubject = new BehaviorSubject<boolean>(false);
  private registrationDialogSubject = new BehaviorSubject<boolean>(false);
  private forgotPasswordDialogSubject = new BehaviorSubject<boolean>(false);
  private profileDialogSubject = new BehaviorSubject<boolean>(false);
  private changePasswordDialogSubject = new BehaviorSubject<boolean>(false);
  private resetPasswordDialogSubject = new BehaviorSubject<boolean>(false);
  private userAccountDeleteDialogSubject = new BehaviorSubject<boolean>(false);

  // Observable streams
  public loginDialog$ = this.loginDialogSubject.asObservable();
  public registrationDialog$ = this.registrationDialogSubject.asObservable();
  public forgotPasswordDialog$ = this.forgotPasswordDialogSubject.asObservable();
  public profileDialog$ = this.profileDialogSubject.asObservable();
  public changePasswordDialog$ = this.changePasswordDialogSubject.asObservable();
  public resetPasswordDialog$ = this.resetPasswordDialogSubject.asObservable();
  public userAccountDeleteDialog$ = this.userAccountDeleteDialogSubject.asObservable();

  // Verification flag subject
  private verificationFailedSubject = new BehaviorSubject<boolean>(false);
  public verificationFailed$ = this.verificationFailedSubject.asObservable();

  constructor() {}

  // Login Dialog Methods
  openLoginDialog(): void {
    this.closeAllDialogs();
    this.loginDialogSubject.next(true);
  }

  closeLoginDialog(): void {
    this.loginDialogSubject.next(false);
  }

  // Registration Dialog Methods
  openRegistrationDialog(): void {
    this.closeAllDialogs();
    this.registrationDialogSubject.next(true);
  }

  closeRegistrationDialog(): void {
    this.registrationDialogSubject.next(false);
  }

  // Forgot Password Dialog Methods
  openForgotPasswordDialog(): void {
    this.closeLoginDialog();
    this.forgotPasswordDialogSubject.next(true);
  }

  closeForgotPasswordDialog(): void {
    this.forgotPasswordDialogSubject.next(false);
  }

  // Profile Dialog Methods
  openProfileDialog(): void {
    this.closeAllDialogs();
    this.profileDialogSubject.next(true);
  }

  closeProfileDialog(): void {
    this.profileDialogSubject.next(false);
  }

  // Change Password Dialog Methods
  openChangePasswordDialog(): void {
    this.closeAllDialogs();
    this.changePasswordDialogSubject.next(true);
  }

  closeChangePasswordDialog(): void {
    this.changePasswordDialogSubject.next(false);
  }

  // Reset Password Dialog Methods
  openResetPasswordDialog(): void {
    this.closeAllDialogs();
    this.resetPasswordDialogSubject.next(true);
  }

  closeResetPasswordDialog(): void {
    this.resetPasswordDialogSubject.next(false);
  }

  // User Account Delete Dialog Methods
  openUserAccountDeleteDialog(): void {
    this.userAccountDeleteDialogSubject.next(true);
  }

  closeUserAccountDeleteDialog(): void {
    this.userAccountDeleteDialogSubject.next(false);
  }

  // Verification Methods
  setVerificationFailed(value: boolean): void {
    this.verificationFailedSubject.next(value);
  }

  // Utility method to close all dialogs
  private closeAllDialogs(): void {
    this.loginDialogSubject.next(false);
    this.registrationDialogSubject.next(false);
    this.forgotPasswordDialogSubject.next(false);
    this.profileDialogSubject.next(false);
    this.changePasswordDialogSubject.next(false);
    this.resetPasswordDialogSubject.next(false);
    this.userAccountDeleteDialogSubject.next(false);
  }

  // Method to switch from login to registration
  switchToRegistration(): void {
    this.closeLoginDialog();
    this.openRegistrationDialog();
  }

  // Method to switch from registration to login
  switchToLogin(): void {
    this.closeRegistrationDialog();
    this.openLoginDialog();
  }

  // Method to switch from login to forgot password
  switchToForgotPassword(): void {
    this.openForgotPasswordDialog();
  }
}
